import { Inbox, type LucideIcon } from 'lucide-react';
import { Card } from './card';

interface EmptyStateProps {
	icon?: LucideIcon;
	title: string;
	description?: string;
	children?: React.ReactNode;
}

export function EmptyState({ icon: Icon = Inbox, title, description, children }: EmptyStateProps) {
	return (
		<Card className="border-line-1 bg-surface py-16">
			<div className="flex flex-col items-center gap-3 text-center">
				<div className="flex h-11 w-11 items-center justify-center rounded-full border border-line-1 bg-surface-fill text-text-3">
					<Icon size={20} />
				</div>
				<div className="text-base text-text-2">{title}</div>
				{description && <div className="text-sm text-text-4">{description}</div>}
				{children}
			</div>
		</Card>
	);
}
